import { fork } from "redux-saga/effects";
import uiSaga from "./ui/uiSaga";

export default function*() {
  yield [fork(uiSaga)];
}



// WEBPACK FOOTER //
// ./src/store/sagas.js